<div mat-dialog-content>
  <p *ngIf="data.message">
    {{ data.message }}
  </p>
  <p *ngIf="!data.message && pair">
    Are you sure you want to {{ !pair.active ? "activate" : "deactivate" }} the pair with Recipient:
    {{ pair.recipient.enisNumber + " - " + pair.recipient.firstName + " " + pair.recipient.lastName }} and Donor:
    {{ pair.donor.enisNumber + " - " + pair.donor.firstName + " " + pair.donor.lastName }}?
  </p>
  <p *ngIf="!data.message && donor">
    Are you sure you want to {{ !donor.active ? "activate" : "deactivate" }} the donor:
    {{ donor.enisNumber + " - " + donor.firstName + " " + donor.lastName }}?
  </p>
  <p *ngIf="!data.message && recipient">
    Are you sure you want to {{ !recipient.active ? "activate" : "deactivate" }} the recipient:
    {{ recipient.enisNumber + " - " + recipient.firstName + " " + recipient.lastName }}?
  </p>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" color="primary" (click)="close()">No</button>
  <ng-container>
    <button mat-raised-button type="submit" color="accent" (click)="toggleConfirm()">Yes</button>
  </ng-container>
</div>
